export function formatDateIfNeeded(dateString) {
  var isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
  if (isoRegex.test(dateString)) {
    return dateString.replace(/([+-]00:00)$/, "Z");
  }
  return "".concat(dateString, "T00:00:00Z");
}
//# sourceMappingURL=utils.js.map